import app from 'flarum/common/app';

/**
 * Ghost or unghost a user via the API, then reload — a ghost/unghost changes
 * what nearly every cached list (discussion list, post streams, search, user
 * list) is allowed to contain, so a full reload is the simplest correct way
 * to reflect it rather than surgically purging each cache.
 *
 * @param {import('flarum/common/models/User').default} user
 * @param {boolean} makeGhost true to ghost, false to unghost
 * @returns {Promise<void>}
 */
export default function toggleGhost(user, makeGhost) {
  const key = makeGhost ? 'ghost' : 'unghost';

  if (!confirm(app.translator.trans(`happydigital-ghost-user.forum.controls.${key}_confirmation`, { username: user.username() }))) {
    return Promise.resolve();
  }

  return app
    .request({
      method: makeGhost ? 'POST' : 'DELETE',
      url: `${app.forum.attribute('apiUrl')}/users/${user.id()}/ghost`,
    })
    .then(() => {
      window.location.reload();
    })
    .catch((error) => {
      app.alerts.show({ type: 'error' }, app.translator.trans('happydigital-ghost-user.forum.controls.error'));
      throw error;
    });
}
